module.exports = "img/flags/RS.78abc75.png";